"use client";
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Icon } from '../../Icon/Icon.web.js';

var _excluded = ["color", "size"];
var IconThisIsFortum = function IconThisIsFortum(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    sizeProp = _ref$size === undefined ? '48px' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var size = sizeProp;
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    viewBox: "0 0 48 48",
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "M39 4.97H17v22h22zm-1 1v20H18v-20zM14 22v-2H9.73l-.216.005A4.73 4.73 0 0 0 5 24.705v9.545l.005.25a4.73 4.73 0 0 0 1.371 3.106l.182.173A4.73 4.73 0 0 0 9.73 39h1.421l4.14 4.207L19.419 39h8.851l.252-.007A4.73 4.73 0 0 0 33 34.232V30h-2v4.24l-.005.2A2.73 2.73 0 0 1 28.27 37h-9.69l-3.29 3.353L11.988 37H9.73l-.197-.007A2.73 2.73 0 0 1 7 34.255V24.71l.006-.165A2.73 2.73 0 0 1 9.73 22zm0 5.97v-1h-4v1zm3 2v1h-7v-1zM31 19l1 1.8a5.67 5.67 0 1 1-5.6-9.8l1.42.38-.38 1.42A3.59 3.59 0 1 0 31 19m-1.359.07a3.18 3.18 0 0 1-3.161-1.59 3.2 3.2 0 0 1 1.18-4.32 3.18 3.18 0 1 1 1.981 5.91",
    clipRule: "evenodd"
  })));
};

export { IconThisIsFortum, IconThisIsFortum as default };
